(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    function updateCartSliderArrows(wrapper) {
    const track = wrapper.querySelector('.ib-slider-track');
    const prevBtn = wrapper.querySelector('.ib-slider-btn--prev');
    const nextBtn = wrapper.querySelector('.ib-slider-btn--next');

    if (!track || !prevBtn || !nextBtn) return;

    const maxScrollLeft = track.scrollWidth - track.clientWidth;

    prevBtn.style.display = track.scrollLeft <= 0 ? 'none' : 'flex';
    nextBtn.style.display = track.scrollLeft >= maxScrollLeft - 2 ? 'none' : 'flex';
  }

  document.addEventListener('click', function (e) {
    /* ---------- SLIDER NEXT ---------- */
    const nextBtn = e.target.closest('.ib-slider-btn--next');
    if (nextBtn) {
      const wrapper = nextBtn.closest('.ib-slider-wrapper');
      const track = wrapper.querySelector('.ib-slider-track');

      track.scrollLeft += 180;
      setTimeout(() => updateCartSliderArrows(wrapper), 150);
      return;
    }

    /* ---------- SLIDER PREV ---------- */
    const prevBtn = e.target.closest('.ib-slider-btn--prev');
    if (prevBtn) {
      const wrapper = prevBtn.closest('.ib-slider-wrapper');
      const track = wrapper.querySelector('.ib-slider-track');

      track.scrollLeft -= 180;
      setTimeout(() => updateCartSliderArrows(wrapper), 150);
      return;
    }

    /* ---------- ADD TO CART ---------- */
    const addBtn = e.target.closest('.ib-add-to-cart-btn');
    if (!addBtn || addBtn.disabled) return;

    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(() => {
        return fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble,header`);
      })
      .then((res) => res.json())
      .then((data) => {
        /* UPDATE DRAWER CONTENT (DAWN SAFE) */
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data['cart-drawer']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newInner = doc.querySelector('.drawer__inner');
          const currentInner = drawer.querySelector('.drawer__inner');

          if (newInner && currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }
        }

        /* UPDATE CART BUBBLE */
        const bubble = document.querySelector('.cart-count-bubble');
        if (bubble && data['cart-icon-bubble']) {
          bubble.innerHTML = data['cart-icon-bubble'];
        }

        /* 🔥 UPDATE HEADER ICONS */
        if (data['header']) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data['header'], 'text/html');

          const newCartIcon = doc.querySelector('.header__icon--cart');
          const currentCartIcon = document.querySelector('.header__icon--cart');

          if (newCartIcon && currentCartIcon) {
            currentCartIcon.innerHTML = newCartIcon.innerHTML;
          }
        }

        /* KEEP DRAWER OPEN */
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .finally(() => {
        addBtn.disabled = false;
      });
  });

  /* Update arrows on swipe/scroll */
  document.addEventListener(
    'scroll',
    function (e) {
      if (!e.target.classList || !e.target.classList.contains('ib-slider-track')) return;
      const wrapper = e.target.closest('.ib-slider-wrapper');
      updateCartSliderArrows(wrapper);
    },
    true
  );

  /* Init arrows on load */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ib-slider-wrapper').forEach((wrapper) => {
      updateCartSliderArrows(wrapper);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
